module.exports = __webpack_public_path__ + "static/media/office sikandar.0bf3675d.jpg";